import { useEffect, useState } from 'react';
import { useIntersectionObserver } from './intersection.js';

/**
 * Used to force a rerender if the attached DOM element changes.
 * Makes any dependant effects happen in a predictable manner.
 */ const useStatefulRef = ()=>{
    const [stateRef, setStateRef] = useState();
    return [
        {
            current: stateRef
        },
        setStateRef
    ];
};
const useInfiniteScroll = ({ loading , hasNextPage , onLoadMore , disabled =false , delayInMS =100 , containerMargin ="0px"  })=>{
    const [containerRef, setContainerRef] = useStatefulRef();
    const [scrollElementRef, setScrollElementRef] = useStatefulRef();
    const scrollElement = useIntersectionObserver(scrollElementRef, {
        // Allow the element to be only partially visible - we're not concerned if its occluded by something slightly.
        // Scroll bars were also interfering with this visibility ratio in some instances.
        ratio: 0.8,
        containerRef,
        containerMargin
    });
    useEffect(()=>{
        if (!disabled && !loading && scrollElement.intersecting && hasNextPage) {
            // When `onLoadMore` is triggered and new items are added to the list, right before they become rendered on the
            // screen, `loading` becomes false and `scrollElement.intersecting` can be true for a brief time, based on the
            // scroll position.
            // A small delay is set when calling 'onLoadMore' to ensure it happens after the first `onLoadMore` is finished.
            const timer = setTimeout(()=>{
                onLoadMore();
            }, delayInMS);
            return ()=>{
                clearTimeout(timer);
            };
        }
    }, [
        onLoadMore,
        delayInMS,
        disabled,
        loading,
        hasNextPage,
        scrollElement.intersecting
    ]);
    return {
        containerRef: setContainerRef,
        scrollElementRef: setScrollElementRef
    };
};

export { useInfiniteScroll };
